export default __webpack_public_path__ + "static/media/Assingment.a6959bcd.svg";